import React from 'react';
import { Shield } from 'lucide-react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <section className="w-full py-10 sm:py-20 bg-violet-rich/20" data-id="element-113">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-violet-deep/60 border border-gold/30 rounded-xl p-5 sm:p-12 text-center" data-id="element-115">
          <Shield className="w-12 h-12 sm:w-16 sm:h-16 text-gold mx-auto mb-4 sm:mb-6" data-id="element-116" />
          <h2 className="font-display text-2xl sm:text-4xl font-bold text-white mb-3 sm:mb-4" data-id="element-117">
            🛡️ 7 DÍAS DE GARANTÍA TOTAL
          </h2>
          <p className="text-sm sm:text-lg text-violet-100/90 mb-3 sm:mb-4 leading-relaxed max-w-2xl mx-auto" data-id="element-118">
            Abrís las guías, probás los bonos con tu primera compra de
            mercadería. Si no es lo que esperabas: sin preguntas, sin
            formularios, sin drama. Te devolvemos el 100%.
          </p>
          <p className="text-xs sm:text-sm text-violet-100/60" data-id="element-119">
            (Tasa de devoluciones &lt; 1%)
          </p>
        </motion.div>
      </div>
    </section>;
}